<script>
import {
    eventGroupState,
    isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { tick } from 'svelte';
import removeEvent from '@cclib/functions/eventGroups/removeEvent.js';
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';
import { getHighlightedDomText, getQuillTextSelection } from '@app/lib/copySelection.js';

let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0 || isSelectedEventGroupLocked());

async function cutEvents(){
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    const eventGroup = eventGroupState[projectState.selected];
    if (!eventGroup?.selected?.length) {
        return;
    }

    const quillSelection = getQuillTextSelection(eventGroup);
    if (quillSelection) {
        quillSelection.editor.deleteText(
            quillSelection.range.index,
            quillSelection.range.length,
        );
        navigator.clipboard.writeText(quillSelection.text);
        insertHistoryAction({
            name: "cut event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
        return;
    }

    const domText = getHighlightedDomText();
    if (domText) {
        navigator.clipboard.writeText(domText);
        return;
    }

    let eventsToCut = [];
    let selectedEvents = eventGroup.selected.map(selectedEvent => {return selectedEvent});

    eventGroupState[projectState.selected].selected = [];
    /* Important! */
    await tick();
    selectedEvents.sort((a, b) => {
        return b - a;
    }).forEach(eventIndex => {
        eventsToCut.push(eventGroupState[projectState.selected].events[eventIndex]);
        eventGroupState[projectState.selected] = removeEvent(eventGroupState[projectState.selected],eventIndex);
    });

    navigator.clipboard.writeText(JSON.stringify(eventsToCut));

    insertHistoryAction({
        name: "cut event(s)", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
}
</script>

<li class="nav-item" title={m.cut_title()}>
    <a 
        class="nav-link" 
        href="#!/" 
        id="cut-event-btn"
        role="button"
        aria-label={m.cut_aria_label()}
        aria-disabled={isDisabled}
        class:disabled={isDisabled} 
        onclick={cutEvents}
    ><i class="bi bi-scissors"></i></a>
</li>
